import { ChartDataPoint } from '@/components/charts/line-chart/LineChart';

export function fillGapsWithNull(data: ChartDataPoint[]): ChartDataPoint[] {
	if (data.length <= 1) {
		return data;
	}

	const hasNumericY = data.every(point => typeof point.y === 'number' || !isNaN(Number(point.y)));
	if (!hasNumericY) {
		return data;
	}

	const intervals: number[] = [];
	for (let i = 1; i < data.length; i++) {
		intervals.push(Number(data[i].x) - Number(data[i - 1].x));
	}

	const sortedIntervals = [...intervals].sort((a, b) => a - b);
	const medianIndex = Math.floor(sortedIntervals.length / 2);
	const expectedInterval =
		sortedIntervals.length % 2 === 0
			? (sortedIntervals[medianIndex - 1] + sortedIntervals[medianIndex]) / 2
			: sortedIntervals[medianIndex];

	if (!expectedInterval || expectedInterval <= 0) {
		return data;
	}

	const result: ChartDataPoint[] = [];

	for (let i = 0; i < data.length; i++) {
		result.push(data[i]);

		if (i < data.length - 1) {
			const currentTimestamp = Number(data[i].x);
			const nextTimestamp = Number(data[i + 1].x);
			const actualInterval = nextTimestamp - currentTimestamp;

			if (actualInterval > expectedInterval) {
				const gapCount = Math.floor(actualInterval / expectedInterval) - 1;

				for (let j = 0; j < gapCount; j++) {
					result.push({
						x: currentTimestamp + expectedInterval * (j + 1),
						y: null
					});
				}
			}
		}
	}

	return result;
}